import { useEffect, useRef, useState } from 'react';

import checkMark from '../../../common/svg/search-bar/checkmark.svg';
import styles from './OptionsSelect.module.css';

export interface option {
  label: string;
  value: string;
  id: string;
  logo?: string | undefined;
  height?: string;
  width?: string;
  logoTailwind?: string;
}

interface Props {
  tailwindBase?: string;
  tailwindDropdown?: string;
  label: string;
  selected: number;
  setSelected: React.Dispatch<React.SetStateAction<number>>;
  listOptions: option[];
  defaultListOption?: number;
}

export const OptionsSelect: React.FC<Props> = props => {
  const [showOptions, setShowOptions] = useState('none');
  const wrapperRef = useRef(null);

  function useOutsideAlerter(ref: { current: any }) {
    useEffect(() => {
      function handleClickOutside(event: { target: any }) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowOptions('none');
        }
      }

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideAlerter(wrapperRef);

  const onSelect = (index: number) => {
    const prevOption: HTMLInputElement | null = document.querySelector(
      `#${props.listOptions[props.selected].id}`,
    );
    const newOption: HTMLInputElement | null = document.querySelector(
      `#${props.listOptions[index].id}`,
    );

    if (prevOption) {
      prevOption.style.display = 'none';
    }

    if (newOption) {
      newOption.style.display = '';
    }

    props.setSelected(index);
  };

  const toggleOptions = () => {
    if (showOptions === 'none') {
      setShowOptions('');
    } else {
      setShowOptions('none');
    }
  };

  return (
    <div
      role="menu"
      tabIndex={0}
      aria-hidden="true"
      ref={wrapperRef}
      className={`${props.tailwindBase} flex flex-col relative`}
      onClick={toggleOptions}
    >
      <span className={styles.label + ' mb-2 ml-1 text-sm font-light'}>
        {props.label}
      </span>
      <div
        className={
          styles.optionsSelect +
          ' w-full h-12 flex flex-col justify-center rounded-full text-center pl-1 pr-6'
        }
      >
        <span className="text-base">
          {props.listOptions[props.selected].label}
        </span>
      </div>
      <div
        className={`${styles.optionsEntry} ${props.tailwindDropdown} absolute top-16 rounded-lg mt-4 z-20`}
        style={{ display: showOptions }}
      >
        {props.listOptions.map((option: option, index: number) => {
          return (
            <div
              role="menu"
              tabIndex={0}
              aria-hidden="true"
              className="w-full mx-0 my-2 pl-2 flex justify-start items-center cursor-pointer hover:opacity-80"
              key={index}
              onClick={() => onSelect(index)}
            >
              {option.logo !== undefined ? (
                <img
                  className={option.logoTailwind}
                  src={option.logo}
                  height={option.height}
                  width={option.width}
                  alt="logo"
                />
              ) : null}
              <span className="ml-1">{option.label}</span>
              {(
                props.defaultListOption
                  ? props.defaultListOption === index
                  : index === 0
              ) ? (
                <img
                  className="ml-2"
                  id={option.id}
                  src={checkMark}
                  height="20"
                  width="20"
                  alt="checkmark"
                  style={{ display: '' }}
                />
              ) : (
                <img
                  className="ml-2"
                  id={option.id}
                  src={checkMark}
                  height="20"
                  width="20"
                  alt="checkmark"
                  style={{ display: 'none' }}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
